import { useEffect, useState } from "react";

export const fmt = (iso) => iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
export const fmtDay = (iso) => iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "";
export const kb = (n) => n >= 1024 ? `${(n / 1024).toFixed(1)} MB` : `${n || 0} KB`;
export const bytes = (n) => !n ? "—" : n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : n >= 1024 ? `${Math.round(n / 1024)} KB` : `${n} B`;
export const minsUntil = (iso, now) => Math.max(1, Math.ceil((new Date(iso) - now) / 60000));
export const minsSince = (iso, now) => Math.max(0, Math.floor((now - new Date(iso)) / 60000));

// Ticks every 30 s so "again in 18 min" counts down without a reload.
export function useNow() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  return now;
}

export const SCHEDULE_LABEL = { hourly: "Every hour", "6h": "Every 6 hours", "12h": "Every 12 hours", daily: "Daily", "3d": "Every 3 days", weekly: "Weekly", monthly: "Monthly" };
export const HOURS = Array.from({ length: 24 }, (_, h) => [h, `${h % 12 === 0 ? 12 : h % 12}${h < 12 ? " am" : " pm"}`]);

export const REASON = {
  noise: "Looks like noise (blog, careers, login…)", thin: "No readable text", manual: "Excluded by you", robots: "Blocked by the site's robots rules",
  error: "Couldn't be read", gone: "No longer on the site", rejected: "Rejected in review", duplicate: "Same file as another document — kept once",
  too_large: "Over the per-file size limit", deferred: "Waiting for the next run (run size budget reached)", web_page_excluded: "Excluded",
  offsite: "Hosted on another website — off-site files are switched off for this site",
};
export const STATUS = {
  queued: ["Queued", "bg-sand-100 text-ink/60"], crawling: ["Reading…", "bg-sky-50 text-sky-700"], ready: ["Ready", "bg-emerald-50 text-emerald-700"],
  error: ["Needs attention", "bg-red-50 text-red-700"], blocked: ["Blocked", "bg-red-50 text-red-700"], thin: ["Needs attention", "bg-amber-50 text-amber-800"],
};
export const CHANGE = {
  added: ["Added", "bg-emerald-50 text-emerald-700"], changed: ["Changed", "bg-sky-50 text-sky-700"], removed: ["Removed", "bg-red-50 text-red-700"],
  restored: ["Restored", "bg-emerald-50 text-emerald-700"], held: ["Held for review", "bg-amber-50 text-amber-800"], duplicates: ["Duplicate", "bg-sand-100 text-ink/60"],
};

export const CTRL = "rounded-lg border border-sand-200 bg-white px-2 py-1.5 text-sm outline-none focus:border-ink";
